<div class="container flex flex-col max-w-2xl px-4 py-8 mx-auto">
    <section class="flex flex-col items-center w-full mb-8 text-center">
        <h1 class="mb-2 text-4xl font-semibold tracking-wide md:text-5xl text-slate-800">About Us</h1>
        @if (showManualSegment) {
            <div class="manual-entity-segment" role="group" aria-label="User manual entity">
                <button
                    type="button"
                    [class.is-selected]="activeManualEntity === InvestEntityType.INVESTOR"
                    [attr.aria-pressed]="activeManualEntity === InvestEntityType.INVESTOR"
                    (click)="setManualEntity(InvestEntityType.INVESTOR)"
                >
                    Investor
                </button>
                <button
                    type="button"
                    [class.is-selected]="activeManualEntity === InvestEntityType.INVESTEE"
                    [attr.aria-pressed]="activeManualEntity === InvestEntityType.INVESTEE"
                    (click)="setManualEntity(InvestEntityType.INVESTEE)"
                >
                    Investee
                </button>
            </div>
        }
    </section>

    <section class="w-full">
        <aside class="flex flex-col p-8 space-y-6 bg-white shadow rounded-2xl">
            <div class="prose max-w-none">
                <h3 class="flex items-center gap-2 text-xl font-semibold text-slate-700">
                    <lucide-icon [img]="File" class="w-5 h-5 text-secondary" />
                    Guidelines
                </h3>
                <ul class="ml-4 list-disc">
                    <li>
                        Read our
                        <button
                            type="button"
                            class="inline-flex items-center gap-1 text-primary hover:underline disabled:opacity-50 disabled:cursor-not-allowed"
                            [disabled]="isLoadingGuidelines"
                            (click)="onGuidelinesClick()"
                        >
                            @if (isLoadingGuidelines) {
                                <lucide-icon [img]="LoaderCircle" class="w-3 h-3 animate-spin" />
                            }
                            <span>Guidelines on the EPIC Program</span>
                        </button>
                        for policies and procedures.
                    </li>
                    <li>
                        Review our
                        <button
                            type="button"
                            class="inline-flex items-center gap-1 text-primary hover:underline disabled:opacity-50 disabled:cursor-not-allowed"
                            [disabled]="isLoadingDataPrivacy"
                            (click)="onDataPrivacyClick()"
                        >
                            @if (isLoadingDataPrivacy) {
                                <lucide-icon [img]="LoaderCircle" class="w-3 h-3 animate-spin" />
                            }
                            <span>Data Privacy Statement</span>
                        </button>
                    </li>
                    <li>
                        View our
                        <a class="text-primary hover:underline" [routerLink]="termsLink">Terms and Conditions</a>
                    </li>
                </ul>
            </div>

            <div class="prose max-w-none">
                <h3 class="flex items-center gap-2 text-xl font-semibold text-slate-700">
                    <lucide-icon [img]="BookOpen" class="w-5 h-5 text-secondary" />
                    User Manual
                </h3>
                <p>
                    Access the
                    <button
                        type="button"
                        class="inline-flex items-center gap-1 text-primary hover:underline disabled:opacity-50 disabled:cursor-not-allowed"
                        [disabled]="isLoadingUserManual"
                        (click)="onUserManualClick()"
                    >
                        @if (isLoadingUserManual) {
                            <lucide-icon [img]="LoaderCircle" class="w-3 h-3 animate-spin" />
                        }
                        <span>EPIC System User Manual - {{ userManualInvestEntityTypeLabel }}</span>
                    </button>
                    for detailed instructions.
                </p>
            </div>

            <div class="prose max-w-none">
                <h3 class="flex items-center gap-2 text-xl font-semibold text-slate-700">
                    <lucide-icon [img]="MailIcon" class="w-5 h-5 text-secondary"></lucide-icon>
                    Support
                </h3>
                <p>
                    Need assistance? Reach out to our support team at
                    <a class="text-primary hover:underline" href="mailto:epicsupport@pdic.gov.ph"
                        >epicsupport&#64;pdic.gov.ph</a
                    >.
                </p>
            </div>

            @if (!isAuthenticated) {
                <div class="pt-6 border-t border-gray-200">
                    <a
                        routerLink="/login"
                        class="inline-flex items-center gap-2 text-sm font-medium text-primary hover:underline"
                    >
                        <lucide-icon [img]="ArrowLeft" class="w-4 h-4"></lucide-icon>
                        Back to Login
                    </a>
                </div>
            }
        </aside>
    </section>
</div>
